module.exports = __webpack_public_path__ + "img/tarj2-1.17108289.svg";